export async function getPermissions(client){return await client.request({method:"wallet_getPermissions"},{dedupe:!0})}